import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() label: string = 'Button';
  @Input() variant: 'primary' | 'secondary' | 'outline' = 'primary';
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Input() fullWidth: boolean = false;
  @Input() color: 'primary' | 'secondary' = 'primary';
  @Input() backgroundColor: string = '#F26135';
  @Input() href?: string | undefined = undefined;

  @Output() clickEvent = new EventEmitter<Event>();

  onClick(event: Event) {
    if (!this.loading && !this.disabled) {
      this.clickEvent.emit(event);
    }
  }
}
